module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_9.a73e6c91.jpg";